// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
}
.nackle-menu .ant-menu {
  padding-bottom: 48px;
}
.nackle-menu .ant-menu.ant-menu-inline-collapsed .ant-menu-submenu-title {
  display: block;
}
.nackle-menu .ant-menu.ant-menu-inline-collapsed svg + span {
  margin-left: unset;
}
.nackle-menu .ant-menu.ant-menu-inline-collapsed .ant-menu-title-content {
  opacity: 0 !important;
}
.nackle-menu .ant-layout-sider .menu-category {
  display: flex;
  align-items: center;
  padding-left: 0.2rem;
}
.nackle-menu .ant-layout-sider .text {
  opacity: 1 !important;
  transition: all 200ms linear;
}
.nackle-menu .ant-layout-sider-collapsed .text {
  opacity: 0 !important;
}
.nackle-menu .ant-menu-submenu-title {
  display: flex;
  align-items: center;
}
.nackle-menu .ant-menu-submenu-title .anticon {
  margin-right: 0.75rem;
}
.nackle-menu .ant-menu-submenu-title .anticon svg {
  width: 1.5rem;
  height: 1.5rem;
}
.nackle-menu .ant-menu-submenu-title svg + span {
  margin-left: 1rem;
}
.nackle-menu .nackle-menu-activity-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.nackle-menu .anticon.menu-icon {
  line-height: 1 !important;
}
.nackle-menu .nackle-menu-collapsed-header {
  display: none;
}
.nackle-menu-collapsed-header .ant-menu-item-group-title {
  font-weight: bold;
  border-bottom: 1px solid rgba(0, 0, 0, 0.45);
}
.nackle-menu-collapsed-header.dark .ant-menu-item-group-title {
  border-bottom: 1px solid rgba(255, 255, 255, 0.65);
}
.nackle-menu .ant-menu-item-group-title:empty {
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./node_modules/.pnpm/@nackle+menu@1.4.25/node_modules/@nackle/menu/dist/nackle-menu.less"],"names":[],"mappings":"AAAA;EACI,SAAA;AACJ;AAEA;EAEQ,oBAAA;AADR;AAGQ;EAEQ,cAAA;AAFhB;AAAQ;EAMQ,kBAAA;AAHhB;AAHQ;EAUQ,qBAAA;AAJhB;AAVA;EAqBY,aAAA;EACA,mBAAA;EACA,oBAAA;AARZ;AAfA;EA2BY,qBAAA;EACA,4BAAA;AATZ;AAnBA;EAkCY,qBAAA;AAZZ;AAtBA;EAyCQ,aAAA;EACA,mBAAA;AAhBR;AA1BA;EA6CY,qBAAA;AAhBZ;AA7BA;EAiDY,aAAA;EACA,cAAA;AAjBZ;AAjCA;EAsDY,iBAAA;AAlBZ;AApCA;EA2DQ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AApBR;AA3CA;EAmEQ,yBAAA;AArBR;AA9CA;EAuEQ,aAAA;AAtBR;AA0BA;EAEQ,iBAAA;EACA,4CAAA;AAzBR;AA6BA;EAEQ,kDAAA;AA5BR;AAgCA;EACI,UAAA;AA9BJ","sourcesContent":["body {\n    margin: 0;\n}\n\n.nackle-menu {\n    .ant-menu {\n        padding-bottom: 48px;\n\n        &.ant-menu-inline-collapsed {\n            .ant-menu-submenu-title {\n                display: block;\n            }\n\n            svg+span {\n                margin-left: unset;\n            }\n\n            .ant-menu-title-content {\n                opacity: 0 !important;\n            }\n        }\n    }\n\n    .ant-layout-sider {\n        .menu-category {\n            display: flex;\n            align-items: center;\n            padding-left: .2rem;\n        }\n\n        .text {\n            opacity: 1 !important;\n            transition: all 200ms linear;\n        }\n    }\n\n    .ant-layout-sider-collapsed {\n        .text {\n            opacity: 0 !important;\n        }\n    }\n\n\n\n    .ant-menu-submenu-title {\n        display: flex;\n        align-items: center;\n\n        .anticon {\n            margin-right: .75rem;\n        }\n\n        .anticon svg {\n            width: 1.5rem;\n            height: 1.5rem;\n        }\n\n        svg+span {\n            margin-left: 1rem;\n        }\n    }\n\n    .nackle-menu-activity-indicator {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n    }\n\n    .anticon.menu-icon {\n        line-height: 1 !important;\n    }\n\n    .nackle-menu-collapsed-header {\n        display: none;\n    }\n}\n\n.nackle-menu-collapsed-header {\n    .ant-menu-item-group-title {\n        font-weight: bold;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.45)\n    }\n}\n\n.nackle-menu-collapsed-header.dark {\n    .ant-menu-item-group-title {\n        border-bottom: 1px solid rgba(255, 255, 255, 0.65);\n    }\n}\n\n.nackle-menu .ant-menu-item-group-title:empty {\n    padding: 0;\n}\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
